import {
  RETRIEVE_EMAIL,
  UPDATE_EMAIL,
} from 'containers/AwarenessCenter/WizardCampaign/steps/GenerateEmailsStep/constants'
import { GET_EMAIL_PREVIEW_ASYNC } from 'containers/AwarenessCenter/WizardCampaign/steps/MessageStep/constants'
import {
  AUTOMATED_LEVEL_BASED_TRAINING,
  CUSTOM_MODULE_IMAGE_PREVIEW,
  CUSTOM_MODULE_NAME_FILE,
  CUSTOM_MODULE_NAME_URL,
  CUSTOM_MODULE_TYPES,
  SOURCE_VALUES,
  TRAINING_VIDEO_TYPES,
} from 'containers/AwarenessCenter/WizardCampaign/steps/TrainingModuleStep/constants'

import {
  CHANGE_SELECTION_DATA,
  CHANGE_TABLE_FILTERS,
  CHANGE_TRAINING_RESULTS_MODAL_POSTPONED_DATE,
  CHANGE_TRAINING_RESULTS_MODAL_STATUS,
  CLEAR_TABLE_FILTERS,
  GET_CAMPAIGN_DATA_ASYNC,
  GET_REPORT_PARTICIPANTS_LIST_ASYNC,
  GET_REPORT_SUMMARY_ASYNC,
  RESET_REPORT,
  RESET_SELECTION_DATA,
  SAVE_DRAFT_ASYNC,
  SAVE_MANUAL_TRAINING_RESULTS_ASYNC,
  SEGMENT_FILTER_CHANGE,
  SET_TABLE_FILTERS,
} from './constants'

const DEFAULT_FILTER = {
  search: '',
  simulationResultTypes: [],
  trainingResultTypes: [],
  departments: [],
  trainingResults: [],
  levels: [],
  scenarios: [],
  trainingIds: [],
}

const DEFAULT_SELECTION_DATA = {
  selectionIds: [],
  allItems: false,
}

export default function () {
  const initialState = {
    data: {},
    loader: false,
    tableLoader: false,
    summaryLoader: false,
    duplicateCampaignLoader: false,
    trainingResultsModalLoader: false,
    error: null,
    segment: null,
    emailPreviewLoader: false,
    emailPreviewError: null,
    emailPreview: null,
    reportParticipantsData: {
      meta: {
        scenarios: [],
        departments: [],
      },
      results: [],
    },
    filters: DEFAULT_FILTER,
    emailDetails: {
      data: null,
      loader: false,
      error: null,
    },
    summaryData: {
      campaignParticipantGroups: [],
      assessments: {},
      statistic: {
        departments: [],
        scenarios: [],
        campaigns: {
          items: [],
        },
      },
    },
    trainingResultsModalStatus: '',
    trainingResultsPostponedDate: null,
    createdCampaignId: null,
    selectionData: DEFAULT_SELECTION_DATA,
  }

  return (state = initialState, action) => {
    switch (action.type) {
      case GET_CAMPAIGN_DATA_ASYNC.INITIATE:
        return {
          ...state,
          loader: true,
        }
      case GET_CAMPAIGN_DATA_ASYNC.SUCCESS: {
        let trainings = []

        if (action.payload.data.trainings.length) {
          trainings = action.payload.data.trainings
          trainings = trainings.map((video) => {
            const videoName =
              video.type === TRAINING_VIDEO_TYPES.CUSTOM_CONTENT.value
                ? video.items[0]?.custom_type === CUSTOM_MODULE_TYPES.CUSTOM_VIDEO
                  ? CUSTOM_MODULE_NAME_FILE
                  : CUSTOM_MODULE_NAME_URL
                : video.name

            return {
              ...video,
              name: videoName,
              vendor: video.vendor || SOURCE_VALUES.CUSTOM_MODULE,
              items: video.items.map((item) => ({
                ...item,
                embeddedSubtitles: item.embedded_subtitles,
                localeId: item.locale,
                customType: item.custom_type,
                imagePreview:
                  video.type === TRAINING_VIDEO_TYPES.CUSTOM_CONTENT.value
                    ? CUSTOM_MODULE_IMAGE_PREVIEW
                    : item.image_preview || '',
              })),
            }
          })
        } else {
          trainings = [AUTOMATED_LEVEL_BASED_TRAINING]
        }

        return {
          ...state,
          error: null,
          data: {
            ...action.payload.data,
            trainings,
          },
          loader: false,
        }
      }
      case GET_CAMPAIGN_DATA_ASYNC.ERROR:
        return {
          ...state,
          error: action.error,
          loader: false,
        }
      case GET_CAMPAIGN_DATA_ASYNC.CANCEL:
        return {
          ...state,
          loader: false,
          segments: null,
        }
      case SEGMENT_FILTER_CHANGE:
        return {
          ...state,
          segment: action.payload.val ? action.payload.val : null,
          loader: true,
          error: null,
        }
      case GET_EMAIL_PREVIEW_ASYNC.INITIATE:
        return {
          ...state,
          emailPreviewError: null,
          emailPreviewLoader: true,
          emailPreview: null,
        }
      case GET_EMAIL_PREVIEW_ASYNC.SUCCESS:
        return {
          ...state,
          emailPreviewLoader: false,
          emailPreview: action.payload.data.response.body,
          data: {
            ...state.data,
            training_campaign_data: {
              ...state.data.training_campaign_data,
              subject: action.payload.data.response.subject,
            },
          },
        }
      case GET_EMAIL_PREVIEW_ASYNC.ERROR:
        return {
          ...state,
          emailPreviewLoader: false,
          emailPreviewError: action.payload.error,
        }
      case GET_REPORT_PARTICIPANTS_LIST_ASYNC.INITIATE:
        return {
          ...state,
          tableLoader: true,
        }
      case GET_REPORT_PARTICIPANTS_LIST_ASYNC.SUCCESS:
        return {
          ...state,
          reportParticipantsData: action.payload.data,
          tableLoader: false,
        }
      case GET_REPORT_PARTICIPANTS_LIST_ASYNC.ERROR:
        return {
          ...state,
          error: action.error,
          tableLoader: false,
        }
      case CHANGE_TABLE_FILTERS:
        return {
          ...state,
          filters: {
            ...state.filters,
            [action.payload.field]: action.payload.value,
          },
        }
      case CLEAR_TABLE_FILTERS:
        return {
          ...state,
          filters: DEFAULT_FILTER,
        }
      case RETRIEVE_EMAIL.INITIATE:
        return {
          ...state,
          emailDetails: {
            data: null,
            error: null,
            loader: true,
          },
        }
      case RETRIEVE_EMAIL.SUCCESS:
        return {
          ...state,
          emailDetails: {
            data: action.payload.data,
            error: null,
            loader: false,
          },
        }
      case RETRIEVE_EMAIL.ERROR:
        return {
          ...state,
          emailDetails: {
            data: null,
            error: action.payload.error,
            loader: false,
          },
        }
      case RETRIEVE_EMAIL.CANCEL:
        return {
          ...state,
          emailDetails: {
            data: null,
            error: null,
            loader: false,
          },
        }
      case GET_REPORT_SUMMARY_ASYNC.INITIATE:
        return {
          ...state,
          summaryLoader: true,
        }
      case GET_REPORT_SUMMARY_ASYNC.SUCCESS:
        return {
          ...state,
          summaryLoader: false,
          summaryData: action.payload.data,
        }
      case GET_REPORT_SUMMARY_ASYNC.ERROR:
        return {
          ...state,
          summaryLoader: false,
        }
      case SAVE_DRAFT_ASYNC.INITIATE:
        return {
          ...state,
          createdCampaignId: null,
          duplicateCampaignLoader: true,
        }
      case SAVE_DRAFT_ASYNC.SUCCESS:
        return {
          ...state,
          duplicateCampaignLoader: false,
          createdCampaignId: action.payload.id,
        }
      case SAVE_DRAFT_ASYNC.ERROR:
        return {
          ...state,
          duplicateCampaignLoader: false,
        }
      case RESET_REPORT:
        return {
          ...initialState,
        }
      case CHANGE_SELECTION_DATA:
        return {
          ...state,
          selectionData: {
            ...state.selectionData,
            [action.payload.field]: action.payload.value,
          },
        }
      case SET_TABLE_FILTERS:
        return {
          ...state,
          filters: action.payload.data,
        }
      case RESET_SELECTION_DATA: {
        return {
          ...state,
          selectionData: DEFAULT_SELECTION_DATA,
        }
      }
      case CHANGE_TRAINING_RESULTS_MODAL_STATUS:
        return {
          ...state,
          trainingResultsModalStatus: action.payload.value,
        }
      case CHANGE_TRAINING_RESULTS_MODAL_POSTPONED_DATE:
        return {
          ...state,
          trainingResultsPostponedDate: action.payload.value,
        }
      case SAVE_MANUAL_TRAINING_RESULTS_ASYNC.INITIATE:
        return {
          ...state,
          trainingResultsModalLoader: true,
        }
      case SAVE_MANUAL_TRAINING_RESULTS_ASYNC.SUCCESS:
        return {
          ...state,
          trainingResultsModalLoader: false,
        }
      case SAVE_MANUAL_TRAINING_RESULTS_ASYNC.ERROR:
        return {
          ...state,
          trainingResultsModalLoader: false,
        }
      case SAVE_MANUAL_TRAINING_RESULTS_ASYNC.CANCEL:
        return {
          ...state,
          trainingResultsModalLoader: false,
        }
      case UPDATE_EMAIL.SUCCESS:
        return {
          ...state,
          emailDetails: {
            data: action.payload.data,
          },
        }
      default:
        return state
    }
  }
}
